var Error404Module = /** @class */ (function () {
    function Error404Module() {
    }
    return Error404Module;
}());
export { Error404Module };
